import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowDown,
  faArrowUp,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowLeft,
  faArrowPointer,
  faBars,
  faCalendar,
  faCamera,
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCheck,
  faChevronRight,
  faChevronDown,
  faCircleCheck,
  faCircleInfo,
  faClipboard,
  faDrawPolygon,
  faEye,
  faEyeSlash,
  faFilter,
  faFloppyDisk,
  faHandPointer,
  faLightbulb as fasLightbulb,
  faLocationDot,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMessage,
  faPencil,
  faPlaneUp,
  faPlus,
  faRotateLeft,
  faRulerHorizontal,
  faRulerVertical,
  faSquareCheck,
  faTrashCan,
  faTriangleExclamation,
  faXmark,
  faVectorSquare,
  faFilePdf,
  faCloudArrowDown,
  faCircleQuestion,
} from '@fortawesome/free-solid-svg-icons'
import { faLightbulb } from '@fortawesome/free-regular-svg-icons'

const IconLibrary = library
const icons = [
  faArrowDown,
  faArrowUp,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowLeft,
  faArrowPointer,
  faBars,
  faCalendar,
  faCamera,
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCheck,
  faChevronRight,
  faChevronDown,
  faCircleCheck,
  faCircleInfo,
  faClipboard,
  faDrawPolygon,
  faEye,
  faEyeSlash,
  faFilter,
  faFloppyDisk,
  faHandPointer,
  faLightbulb,
  fasLightbulb,
  faLocationDot,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMessage,
  faPencil,
  faPlus,
  faPlaneUp,
  faRotateLeft,
  faRulerHorizontal,
  faRulerVertical,
  faSquareCheck,
  faTrashCan,
  faTriangleExclamation,
  faVectorSquare,
  faXmark,
  faFilePdf,
  faCloudArrowDown,
  faCircleQuestion,
]
icons.forEach((icon) => IconLibrary.add(icon))

export default FontAwesomeIcon
